/*
 * File: OrderViews.js
 * Project: mp-mobile-app
 *
 * Created by jeddumire on 11/18/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: MST Views for an individual order
 */
import DateFormatter from "utils/DateFormatter";
import Users from "services/users/Users";
import OrderReferences from "../OrderReferences";
import References from "services/references/References";
import { getEnv } from "mobx-state-tree";
import { format } from "date-fns";

const OrderViews = self => ({
  /**
   * Concats first and last of patient
   *
   * @return {String}
   */
  get patientName() {
    return self.patientFirst ? self.patientFirst + " " + self.patientLast : "";
  },

  /**
   * Concats first and last of provider
   *
   * @return {String}
   */
  get providerName() {
    const provider = getEnv(self)
      .storeManager.getStore(Users)
      .providerById(self.providerId);
    return provider ? provider.firstName + " " + provider.lastName : "";
  },

  /**
   * Concats first and last of assignedTo
   *
   * @return {String}
   */
  get assignedToName() {
    const user = getEnv(self)
      .storeManager.getStore(Users)
      .userById(self.assignedToUserId);
    return user ? user.firstName + " " + user.lastName : "";
  },

  /**
   * Formats date self.ordered
   *
   * @return {String}
   */
  get orderedDate() {
    return self.ordered ? DateFormatter.mdy(self.ordered) : "";
  },

  /**
   * Formats date self.ordered
   *
   * @return {String}
   */
  get dueDate() {
    return self.due ? format(self.due, "MM/dd/yyyy") : "";
  },

  typeString(storeManager) {
    const orderType = storeManager
      .getStore(OrderReferences)
      .typeById(self.typeId);
    return orderType;
  },

  statusString(storeManager) {
    const orderStatus = storeManager
      .getStore(OrderReferences)
      .statusById(self.orderStatusId);
    return orderStatus;
  },

  officeString(storeManager) {
    let orderOffice = storeManager
      .getStore(References)
      .officeById(self.officeId);
    return orderOffice;
  },

  incident(storeManager) {
    let orderIncident = storeManager
      .getStore(OrderReferences)
      .incidentById(self.incidentId);
    return orderIncident;
  }
});

export default OrderViews;
